import { Button } from '@library/components/buttons';
import { classNames } from '@library/utils';

export interface LinkButtonProps {
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  label: React.ReactNode;
}

export const LinkButton = ({
  className = '',
  disabled = false,
  onClick,
  label
}: LinkButtonProps) => {
  return (
    <Button
      className={classNames(
        'text-soClean-180 cursor-pointer text-sm font-medium',
        className
      )}
      disabled={disabled}
      title="LinkButton"
      onClick={onClick}
      type="button"
    >
      {label}
    </Button>
  );
};
